export const Hero = () => (
  <header data-testid="hero-section" className="px-6 md:px-12 pt-16 pb-20 md:py-24 max-w-6xl mx-auto">
    <div className="mono-lbl text-xs uppercase text-[#FF2E88] font-bold mb-4 flex items-center gap-2">
      <span className="w-2 h-2 rounded-full bg-[#FF2E88] animate-ping" />
      <span data-testid="mission-badge">Inclusive Video Games Cafe</span>
    </div>
    <h1 className="display-type text-5xl sm:text-7xl md:text-8xl font-black text-[#F5EFE6] mb-8 uppercase">
      <span className="ln"><span>Fresh Espresso.</span></span>
      <span className="ln"><span>Retro Games.</span></span>
      <span className="ln"><span className="text-[#FF2E88]">Equal Joy.</span></span>
    </h1>
    <div className="grid md:grid-cols-12 gap-8 items-end">
      <p
        data-testid="hero-subline"
        className="md:col-span-7 text-lg md:text-xl text-[#C9BEDC] leading-relaxed hero-fade"
      >
        A neighborhood coffee hangout proudly run with people with a disability, serving crafted
        roast and vintage video games for all.
      </p>
      <div className="md:col-span-5 flex flex-col sm:flex-row gap-3 md:justify-end hero-pill">
        <a
          data-testid="hero-visit-btn"
          href="#visit"
          className="inline-flex items-center justify-center px-6 py-4 rounded-xl bg-[#F5EFE6] text-[#1B0F2E] font-bold text-sm uppercase mono-lbl hover:bg-[#FF2E88] transition-colors shadow-sm"
        >
          Visit Us Today &rarr;
        </a>
      </div>
    </div>
  </header>
);
